import { Divider } from "antd"
import { useState } from "react"
import Icon, { ICON_NAME } from "../../../components/Icon"
import { ChartProvider } from "../../../contexts/ChartContext"
import { IFishgroupSelected } from "../List"
import Chart from "./Chart"
import Title from "./Title"
import styles from "./style.module.scss"

const FishGroup: React.FC<{ data: IFishgroupSelected, onClear(): void }> = ({ data, onClear }) => {
    return <div className="px-2">
        <div className="flex justify-between">
            <div className="text-[20px] flex items-center">
                <div>{data.site_name}</div>
                <Divider orientation="vertical" />
                <div>{data.group_name}</div>
            </div>
            <div className="bt-ghost" data-icon="true" onClick={onClear}>
                <Icon icon={ICON_NAME.CLOSE} />
            </div>
        </div>
        <Chart data={data} />
    </div>
}

interface IProps {
    source: IFishgroupSelected[]
    onClose?(): void
}

const FishGroupChart: React.FC<IProps> = ({ source = [] }) => {
    const [selected, setSelected] = useState(source)

    return <div className={styles.container}>
        <Title onChange={setSelected} />
        <div className="flex flex-col gap-3">
            <ChartProvider>
                {selected.map(item => <FishGroup
                    key={item.group_id}
                    data={item}
                    onClear={() => setSelected(prev => prev.filter(sub => sub.group_id !== item.group_id))}
                />)}
            </ChartProvider>
        </div>
    </div>
}

export default FishGroupChart